import { Link } from 'react-router-dom';
import { articles } from '@/mocks/siteData';
import ArticleCard from '@/components/feature/ArticleCard';

export default function ArticleList() {
  const featuredArticles = articles.filter((a) => a.featured);
  const latestArticles = articles.slice().sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime());
  const categoryMap: Record<string, string> = {
    gaoxiao: '搞笑猫咪',
    mengchong: '萌宠日常',
    duanpian: '萌猫短片',
    zhiyu: '治愈猫咪',
    youmao: '幼猫成长',
    catknowledge: '养猫知识',
  };

  return (
    <>
      <section className="py-14 md:py-20 bg-background-50">
        <div className="max-w-[1400px] mx-auto px-4 md:px-6">
          <div className="flex items-center justify-between mb-8">
            <div>
              <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-800 mb-2">
                热门推荐
              </h2>
              <p className="text-foreground-500 text-sm">编辑精选，不容错过的爆款猫咪视频</p>
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-6">
            {featuredArticles.slice(0, 4).map((article) => (
              <ArticleCard
                key={article.id}
                id={article.id}
                title={article.title}
                excerpt={article.excerpt}
                categorySlug={article.category}
                categoryName={categoryMap[article.category] || article.category}
                imageUrl={article.imageUrl}
                date={article.date}
                readTime={article.readTime}
                views={article.views}
                featured={true}
              />
            ))}
          </div>
        </div>
      </section>

      <section className="py-14 md:py-20 bg-background-100">
        <div className="max-w-[1400px] mx-auto px-4 md:px-6">
          <div className="flex items-center justify-between mb-8">
            <div>
              <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-800 mb-2">
                最新视频
              </h2>
              <p className="text-foreground-500 text-sm">每日更新最新猫咪视频内容</p>
            </div>
            <Link
              to="/category/gaoxiao"
              className="hidden sm:flex items-center gap-1 text-sm font-medium text-primary-500 hover:text-primary-600 transition-colors whitespace-nowrap"
            >
              查看全部
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
            {latestArticles.map((article) => (
              <ArticleCard
                key={article.id}
                id={article.id}
                title={article.title}
                excerpt={article.excerpt}
                categorySlug={article.category}
                categoryName={categoryMap[article.category] || article.category}
                imageUrl={article.imageUrl}
                date={article.date}
                readTime={article.readTime}
                views={article.views}
                featured={false}
              />
            ))}
          </div>
        </div>
      </section>
    </>
  );
}